import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52cccfe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "my-info" }
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Сводный" }, null, -1))
const _hoisted_4 = { class: "template-header" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "text-center my-1 my-none" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex not-excel ml-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "no-border" }, "Группировать по", -1))
const _hoisted_10 = { class: "no-border" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "undefined" }, "Не группировать", -1))
const _hoisted_12 = ["value", "innerHTML"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "no-border" }, "Сортировать по", -1))
const _hoisted_14 = { class: "no-border" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "undefined" }, "Не сортировать", -1))
const _hoisted_17 = ["value", "innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "text-center d-none" }
const _hoisted_21 = {
  key: 0,
  class: "d-none"
}
const _hoisted_22 = {
  key: 1,
  class: "d-none"
}
const _hoisted_23 = {
  class: "text-align-center",
  "data-excelautofilter": "",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px"}
}
const _hoisted_24 = { class: "sticky" }
const _hoisted_25 = { class: "border-bottom-tr print-repeat print-frozen-row" }
const _hoisted_26 = ["onMouseenter", "onMouseleave"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Описание адресов и FMI" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center footer-desc q-my-xs q-mt-md" }, " Описание стандарных функций адресов сети CAN и FMI указанных на первом листе отчета Активные диагностические коды неисправности DTC в сети CAN J1939 ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-my-md" }, null, -1))
const _hoisted_33 = {
  class: "text-align-center sticky-table-header",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px"}
}
const _hoisted_34 = { class: "sticky" }
const _hoisted_35 = { class: "border-bottom-tr print-repeat" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-my-md" }, null, -1))
const _hoisted_39 = {
  class: "text-align-center sticky-table-header",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px"}
}
const _hoisted_40 = { class: "sticky" }
const _hoisted_41 = { class: "border-bottom-tr print-repeat" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';

import {
  formatDateHelper,
  formatTimeHelper,
  wait,
  formatTimeHelper2
} from '@/helpers/main_helper';

import {
  GROUP_BY_OPTIONS,
  SORT_BY_OPTIONS,
  DEFAULT_DESCENDING,
} from './Config';
import { PosDtcLabels, Addr, Fmi } from '@/Template/Diagnostic/Aggregation';

import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';

import type {
  ReportCalculated,
  ReportName,
} from '@/Template/Diagnostic/Diagnostic';
import type { DiagnosticRow } from '@/Template/Diagnostic/Diagnostic';
import type { IPeriod } from '@/Template/Smenas';
import type { GroupBy, SortBy } from './Config';
import {
  addHoverOnTarget,
  removeHoverOnTarget,
} from '@/App/helpers/targetsHelper';

export interface Props {
  areaId: string;
  name: ReportName;
  data: { areaId: string; data: ReportCalculated };
}

type Row = { [key: string]: string | number | null | undefined | PosDtcLabels };

type Column = {
  label: string;
  name: string;
  format: (row: Row, index: number) => number | string | `'-`;
  banner?: string;
  headAttrs?: {
    [key: string]: any;
  };
  bodyAttrs?: (
    row: Row,
    index: number,
  ) => {
    [key: string]: any;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosticTemplate',
  props: {
    areaId: null,
    name: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
  areaId: string;
  name: ReportName;
  data: { areaId: string; data: ReportCalculated };
}

const DIAGNOSTIC_AGGREGATION_ROW = {
  name: '0',
  stateNumber: '1',
  begin: '2',
  interval: '3',
  code: '4',
  MIF: '5',
  IS: '6',
  OC: '7',
  lamp1: '8',
  lamp2: '9',
  addr: '10',
  priority: '11',
  posDtcLabels: '12',
};



const SUMM_ROW_NAME = 'ИТОГО:';
const DEFAULT_SORT_COLUMN_NAME = 'time';
const NOT_DATA = 'н/д';
const NOT_VIOLATION = 'ошибок кан не зафиксировано';
const EMPTY = '-';

const YELLOW_SIGNAL_RIGHT_OFFSET = 2;
const YELLOW_SIGNAL_STRING = 'предупреждение, проверьте узел';

const RED_SIGNAL_RIGHT_OFFSET = 4;
const RED_SIGNAL_STRING = 'эксплуатировать машину не рекомендуется';

const diagnosticParameterFormat: (name: string) => Column['format'] =
  (name) => (row: Row) => {
    if (row['name'] === SUMM_ROW_NAME && name !== 'stateNumber') return '';

    const val = row[name];
    if (typeof val === 'object') {
      return '?';
    }
    return val == null || val == undefined ? EMPTY : val;
  };

const getIntervalBodyAttrs = (val: Row[keyof Row]) => {
  if (typeof val === 'object') {
    val = '?';
  }
  if (val === null || val === undefined) {
    val = NOT_DATA;
  }

  let dataFormatNum = 0;
  let dataValue = val;
  if (
    (typeof val === 'string' || typeof val === 'number') &&
    !Number.isNaN(+val)
  ) {
    dataFormatNum = 4;
    dataValue = +val / 86400;
  }

  return {
    'data-formatnum': dataFormatNum,
    'data-value': dataValue,
  };
};

const getFullDate = (d: number) => {
  return formatDateHelper(new Date(d * 1000), 'dd.mm.yyyy hh:nn:ss');
};

const formatSignal =
  (rightOffset: number, value: string, notData: string) =>
  (row: Row, index: number) => {
    const val = row['lamp1'];
    if (val === null || val === undefined) {
      return notData;
    } else {
      return ((+val >> rightOffset) & 3) === 1 ? value : notData;
    }
  };

const isActualSpn = (sm: number) => {
  return sm == 0;
};

const ADDRESS_COLUMNS = [
  {
    label: 'Адрес в сети CAN',
    name: 'addressNumber',
    format: (row: string[]) => {
      const globalGroupId = 0;

      const [addrId, gname, label, func, gid] = row;

      if (+gid != globalGroupId) {
        return `${addrId} группа ${gname}`;
      }

      return row[0] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 200px',
      'data-minwidth': '27',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '12',
      'class': 'text-left vertical-top',
    },
  },
  {
    label: 'Назначение адреса',
    name: 'addressName',
    format: (row: Addr) => {
      return row[2] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 265px',
      'data-minwidth': '38',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '0',
      'class': 'text-left vertical-top',
    },
  },
  {
    label: 'Стандарная функция адреса',
    name: 'addressFunction',
    format: (row: Addr) => {
      return row[3] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 950px',
      'data-minwidth': '130',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '0',
      'class': 'text-left vertical-top',
    },
  },
];
const FMI_COLUMNS = [
  {
    label: 'FMI (идентификатор режима сбоя)',
    name: 'fmiNumber',
    format: (row: [string, string, string]) => {
      return row[0] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 200px',
      'data-minwidth': '27',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '12',
      'class': 'text-left vertical-top',
    },
  },
  {
    label: 'Описание FMI',
    name: 'fmiDescription',
    format: (row: [string, string, string]) => {
      return row[1] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 265px',
      'data-minwidth': '38',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '0',
      'class': 'text-left vertical-top',
    },
  },
  {
    label: 'Комментарий',
    name: 'fmiComment',
    format: (row: [string, string, string]) => {
      return row[2] || EMPTY;
    },
    headAttrs: {
      'style': 'min-width: 950px',
      'data-minwidth': '130',
      'class': 'text-left vertical-top',
    },
    bodyAttrs: {
      'data-formatnum': '0',
      'class': 'text-left vertical-top',
    },
  },
];

const COLUMNS: { [Name: string]: Column } = {
  Model: {
    label: 'Марка',
    name: 'model',
    format: (row) => {
      if (row['name'] === SUMM_ROW_NAME) return row['name'];
      const val = row['model'];

      if (typeof val === 'number' && val != null) {
        const delta = Number.isNaN(val)
          ? 'не получено'
          : formatTimeHelper(val / 86400, 'tt:nn:ss');
        return 'Общий моторесурс: ' + delta;
      }
      if (val === '') {
        return '';
      }
      return (val as string) || 'не известно';
    },
    headAttrs: {
      'style': 'min-width: 150px',
      'data-minwidth': '16',
    },
    bodyAttrs: () => ({
      'data-formatnum': '0',
    }),
  },
  Name: {
    label: 'Наименование',
    name: 'name',
    format: diagnosticParameterFormat('name'),
    headAttrs: {
      'style': 'min-width: 150px',
      'data-minwidth': '16',
    },
    bodyAttrs: () => ({
      'data-formatnum': '0',
    }),
  },
  StateNumber: {
    label: 'Гос №',
    name: 'stateNumber',
    format: diagnosticParameterFormat('stateNumber'),
    headAttrs: {
      'style': { minWidth: '150px' },
      'data-minwidth': '16',
      'data-formatnum': '0',
    },
  },
  Begin: {
    label: 'Начало',
    name: 'time',
    format: (row) => {
      const val = row['begin'];

      if (typeof val === 'object') {
        return '?';
      }

      return val == null || typeof val !== 'number' ? EMPTY : getFullDate(val);
    },
    headAttrs: {
      'style': { minWidth: '150px' },
      'data-minwidth': 18,
    },
  },
  Time: {
    label: 'Время',
    name: 'time',
    format: (row) => {
      const val = row['begin'];

      if (typeof val === 'object') {
        return '?';
      }

      return val == null || typeof val !== 'number' ? EMPTY : getFullDate(val);
    },
    headAttrs: {
      'style': { minWidth: '150px' },
      'data-minwidth': 18,
    },
  },
  Interval: {
    label: 'Интервал',
    name: 'interval',
    format: (row) => {
      const val = row['interval'];

      if (typeof val === 'object') {
        return '?';
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '100px' },
      'data-minwidth': 10,
    },
  },
  Code: {
    label: 'Код',
    name: 'code',
    format: diagnosticParameterFormat('code'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Mif: {
    label: 'MIF',
    name: 'mif',
    format: diagnosticParameterFormat('mif'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Is: {
    label: 'IS',
    name: 'is',
    format: diagnosticParameterFormat('is'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Os: {
    label: 'OS',
    name: 'os',
    format: diagnosticParameterFormat('os'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Lamp1: {
    label: 'Лампа 1',
    name: 'lamp1',
    format: diagnosticParameterFormat('lamp1'),
    headAttrs: {
      'style': { minWidth: '80px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Lamp2: {
    label: 'Лампа 2',
    name: 'lamp2',
    format: diagnosticParameterFormat('lamp2'),
    headAttrs: {
      'style': { minWidth: '80px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  YellowSignal: {
    label: 'Желтый сигнал',
    name: 'lamp1',
    format: formatSignal(
      YELLOW_SIGNAL_RIGHT_OFFSET,
      YELLOW_SIGNAL_STRING,
      EMPTY,
    ),
    banner: YELLOW_SIGNAL_STRING,
    headAttrs: {
      'style': { minWidth: '80px' },
      'data-minwidth': 20,
    },
    bodyAttrs: (row, index) => ({
      'data-formatnum': 15,
      'data-value': formatSignal(
        YELLOW_SIGNAL_RIGHT_OFFSET,
        YELLOW_SIGNAL_STRING,
        '0',
      )(row, index),
    }),
  },
  RedSignal: {
    label: 'Красный сигнал',
    name: 'lamp1',
    format: formatSignal(RED_SIGNAL_RIGHT_OFFSET, RED_SIGNAL_STRING, EMPTY),
    headAttrs: {
      'style': { minWidth: '80px' },
      'data-minwidth': 20,
    },
    banner: RED_SIGNAL_STRING,
    bodyAttrs: (row, index) => ({
      'data-formatnum': 15,
      'data-value': formatSignal(
        RED_SIGNAL_RIGHT_OFFSET,
        RED_SIGNAL_STRING,
        '0',
      )(row, index),
    }),
  },
  Adress: {
    label: 'Адрес',
    name: 'address',
    format: diagnosticParameterFormat('addr'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Priority: {
    label: 'Приоритет',
    name: 'priority',
    format: diagnosticParameterFormat('priority'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  Counter: {
    label: 'Счетчик',
    name: 'counter',
    format: diagnosticParameterFormat('counter'),
    headAttrs: {
      'style': { minWidth: '65px' },
      'data-minwidth': 8,
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
    }),
  },
  AddressWithDescription: {
    label:
      'Адрес источника контроллера с сети CAN/стандартное назначение адреса в сети CAN J1939',
    name: 'address-with-description',
    format: (row) => {
      if (row['name'] === SUMM_ROW_NAME) return '';

      const addr = row['addr'];
      const posDtcLabels = row['posDtcLabels'];

      if (typeof addr === 'object') {
        return '?';
      }
      if (addr === null || addr === undefined) {
        return NOT_DATA;
      }
      if (typeof addr === 'string') {
        return addr;
      }
      if (!posDtcLabels || typeof posDtcLabels !== 'object') {
        return 'не получено';
      }

      if (!(addr in posDtcLabels?.addrs)) {
        return addr;
      }

      const arr = posDtcLabels?.addrs[addr + ''];
      return addr + '; ' + arr.map((val) => val[1] || 'нет').join(', ');
    },
    headAttrs: {
      'style': { minWidth: '250px' },
      'data-minwidth': 32,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      'data-formatnum': 0,
      'class': 'text-left vertical-top',
      'data-font-size': '12',
    }),
  },
  SpnCode: {
    label: 'SPN код (активные коды неисправности DTC)',
    name: 'code',
    format: (row) => {
      if (row['name'] === SUMM_ROW_NAME) return '';

      const v1Code = row['code'] as string;
      const sm = row['is'] as number;

      if (typeof v1Code === 'object') {
        return '?';
      }
      if (v1Code === null || v1Code === undefined) {
        return NOT_DATA;
      }
      if (typeof v1Code === 'string') {
        return v1Code;
      }

      if (isActualSpn(sm)) {
        return v1Code || 'не получено';
      } else {
        const posDtcLabels = row['posDtcLabels'] as PosDtcLabels;
        const v2Code = posDtcLabels?.spnsOld?.[v1Code]?.[0];
        const v3Code = posDtcLabels?.spnsOld?.[v1Code]?.[3];

        return `v1: ${v1Code || 'нет'}; v2: ${v2Code || 'нет'}; v3: ${
          v3Code || 'нет'
        }`;
      }
    },
    headAttrs: {
      'style': { minWidth: '120px' },
      'data-minwidth': 17,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      'data-formatnum': 0,
      'class': 'text-left vertical-top',
    }),
  },
  SmVariant: {
    label: 'Способ передачи SPN по сети CAN',
    name: 'variant',
    format: (row) => {
      const is = row['is'] as number;
      return is == 0 || is == 1
        ? isActualSpn(is)
          ? 'актуальный'
          : 'устаревший'
        : is;
    },
    headAttrs: {
      'style': { minWidth: '80px' },
      'data-minwidth': 11,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      'data-formatnum': 0,
      'class': 'text-left vertical-top',
    }),
  },
  SpnDescription: {
    label: 'Описание SPN кода',
    name: 'spn-description',
    format: (row) => {
      if (row['name'] === SUMM_ROW_NAME) return '';

      const code = row['code'] as string;
      const is = row['is'] as number;
      const posDtcLabels = row['posDtcLabels'];

      if (typeof code === 'object') {
        return '?';
      }
      if (code === null || code === undefined) {
        return NOT_DATA;
      }
      if (typeof code === 'string') {
        if (code === NOT_VIOLATION) return EMPTY;
        return code;
      }

      if (!posDtcLabels || typeof posDtcLabels !== 'object') {
        return 'не получено';
      }

      if (isActualSpn(is)) {
        if (code in posDtcLabels?.spns) {
          return posDtcLabels?.spns[code].map((val) => val || 'нет').join('; ');
        } else {
          return 'не получено';
        }
      } else {
        if (code in posDtcLabels?.spnsOld) {
          const v1SpnLabel = posDtcLabels?.spnsOld?.[code]?.[1] || 'нет';
          const v2SpnLabel = posDtcLabels?.spnsOld?.[code]?.[2] || 'нет';
          const v3SpnLabel = posDtcLabels?.spnsOld?.[code]?.[4] || 'нет';
          return `v1: ${v1SpnLabel}; v2: ${v2SpnLabel}; v3: ${v3SpnLabel}`;
        } else {
          return 'не получено';
        }
      }
    },
    headAttrs: {
      'style': { minWidth: '215px' },
      'data-minwidth': 30,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      'data-formatnum': 0,
      'class': 'text-left vertical-top',
    }),
  },
  SpnInterval: {
    label: 'Общее время SPN',
    name: 'interval',
    format: (row) => {
      const val = row['interval'];

      if (typeof val === 'object') {
        return '?';
      }
      if (val === null || val === undefined) {
        return NOT_DATA;
      }
      if (typeof val === 'string') {
        return val;
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '76px' },
      'data-minwidth': 11,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: (row) => {
      const val = row['interval'];
      return {
        ...getIntervalBodyAttrs(val),
        class: 'text-left vertical-top',
      };
    },
  },
  RedLamp: {
    label: 'Время "Красная лампа" (требуется остановка ТС)',
    name: 'red-lamp',
    format: (row) => {
      const val = row['redLampInterval'];

      if (typeof val === 'object') {
        return '?';
      }
      if (val === null || val === undefined) {
        return NOT_DATA;
      }
      if (typeof val === 'string') {
        return val;
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '100px' },
      'data-minwidth': 14,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: (row) => {
      const val = row['redLampInterval'];
      return {
        ...getIntervalBodyAttrs(val),
        class: 'text-left vertical-top',
      };
    },
  },
  YellowLamp: {
    label:
      'Время "Желтая лампа" (предупреждение, не требуется немедленная остановка ТС)',
    name: 'yellow-lamp',
    format: (row) => {
      const val = row['yellowLampInterval'];

      if (typeof val === 'object') {
        return '?';
      }
      if (val === null || val === undefined) {
        return NOT_DATA;
      }
      if (typeof val === 'string') {
        return val;
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '100px' },
      'data-minwidth': 14,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: (row) => {
      const val = row['yellowLampInterval'];
      return {
        ...getIntervalBodyAttrs(val),
        class: 'text-left vertical-top',
      };
    },
  },
  CO2ErrorInterval: {
    label: 'Время ошибки влияющей на выбросы СО2',
    name: 'co2-error',
    format: (row) => {
      const val = row['CO2ErrorInterval'];

      if (typeof val === 'object') {
        return '?';
      }
      if (val === null || val === undefined) {
        return NOT_DATA;
      }
      if (typeof val === 'string') {
        return val;
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '120px' },
      'data-minwidth': 16,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: (row) => {
      const val = row['CO2ErrorInterval'];
      return {
        ...getIntervalBodyAttrs(val),
        class: 'text-left vertical-top',
      };
    },
  },
  NoSubsystemErrorInterval: {
    label: 'Время ошибки, не связаной с электронной подсистемой',
    name: 'no-subsystem-error-interval',
    format: (row) => {
      const val = row['noSubsystemErrorInterval'];

      if (typeof val === 'object') {
        return '?';
      }
      if (val === null || val === undefined) {
        return NOT_DATA;
      }
      if (typeof val === 'string') {
        return val;
      }

      return val == null || typeof val !== 'number'
        ? EMPTY
        : formatTimeHelper(val / 86400, 'tt:nn:ss');
    },
    headAttrs: {
      'style': { minWidth: '120px' },
      'data-minwidth': 16,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: (row) => {
      const val = row['noSubsystemErrorInterval'];
      return {
        ...getIntervalBodyAttrs(val),
        class: 'text-left vertical-top',
      };
    },
  },
  Fmi: {
    label: 'FMI(идентификатор режима сбоя)',
    name: 'fmi',
    format: (row) => {
      if (row['name'] === SUMM_ROW_NAME) return '';

      const fmi = row['mif'] as number;
      const posDtcLabels = row['posDtcLabels'];

      if (typeof fmi === 'object') {
        return '?';
      }
      if (fmi === null || fmi === undefined) {
        return NOT_DATA;
      }
      if (typeof fmi === 'string') {
        return fmi;
      }

      if (!posDtcLabels || typeof posDtcLabels !== 'object') {
        return 'не получено';
      }

      if (fmi in posDtcLabels?.fmis) {
        return posDtcLabels?.fmis[fmi][0] || 'не получено';
      } else {
        return 'не получено';
      }
    },
    headAttrs: {
      'style': { minWidth: '700px' },
      'data-minwidth': 96,
      'class': 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      'data-formatnum': 12,
      'class': 'text-left vertical-top',
    }),
  },
};

const COLUMNS_AGGREGATION = [
  COLUMNS.Name,
  COLUMNS.StateNumber,
  COLUMNS.Begin,
  COLUMNS.Interval,
  COLUMNS.Code,
  COLUMNS.Mif,
  COLUMNS.Is,
  COLUMNS.Os,
  COLUMNS.YellowSignal,
  COLUMNS.RedSignal,
  COLUMNS.Adress,
  COLUMNS.Priority,
];
const COLUMNS_DETAIL = [
  COLUMNS.Name,
  COLUMNS.StateNumber,
  COLUMNS.Time,
  COLUMNS.Code,
  COLUMNS.Mif,
  COLUMNS.Is,
  COLUMNS.Os,
  COLUMNS.YellowSignal,
  COLUMNS.RedSignal,
  COLUMNS.Adress,
  COLUMNS.Priority,
  COLUMNS.Counter,
];
const COLUMNS_AGGREGATION_WITH_DESCRIPTION: Column[] = [
  {
    ...COLUMNS.Model,
    headAttrs: {
      ...COLUMNS.Model.headAttrs,
      class: 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      ...COLUMNS.Model.bodyAttrs,
      class: 'text-left vertical-top',
    }),
  },
  {
    ...COLUMNS.StateNumber,
    headAttrs: {
      ...COLUMNS.StateNumber.headAttrs,
      class: 'text-left vertical-top',
    },
    bodyAttrs: () => ({
      ...COLUMNS.StateNumber.bodyAttrs,
      class: 'text-left vertical-top',
    }),
  },
  COLUMNS.AddressWithDescription,
  COLUMNS.SpnCode,
  COLUMNS.SmVariant,
  COLUMNS.SpnDescription,
  COLUMNS.SpnInterval,
  COLUMNS.RedLamp,
  COLUMNS.YellowLamp,
  COLUMNS.CO2ErrorInterval,
  COLUMNS.NoSubsystemErrorInterval,
  COLUMNS.Fmi,
];
const COLUMNS_BY_REPORT_NAME: { [key in ReportName]: Column[] } = {
  diagnostic: COLUMNS_AGGREGATION,
  diagnosticDetail: COLUMNS_DETAIL,
  descriptionDiagnostic: COLUMNS_AGGREGATION_WITH_DESCRIPTION,
};

const groupBy = ref<GroupBy>();

const sortBy = ref<SortBy>();
const descending = ref<boolean>(DEFAULT_DESCENDING);

const loading = ref<boolean>(false);

const rows = reactive<Row[]>([]);
const rowsStyles = reactive<{ [key: string]: string }[]>([]);

const REPORT_LABEL = computed(() => {
  if (props.name === 'descriptionDiagnostic') {
    return 'Диагностика ТС с описанием.<br>Активные диагностические коды неисправности DTC в сети CAN J1939.';
  }
  return props.name === 'diagnostic'
    ? 'Диагностика'
    : 'Диагностика (подробный)';
});

const interval = computed(() => {
  const from = getFullDate(props.data.data.responseInterval.from / 1000);
  const to = getFullDate(props.data.data.responseInterval.to / 1000);

  return `с ${from} по ${to}`;
});

const addresses = computed(() => {
  const addrs = props.data.data.objects.reduce((acc, object) => {
    if (!object.posDtcLabels?.addrs) {
      return acc;
    }

    for (const addrId in object.posDtcLabels?.addrs) {
      const addrs = object.posDtcLabels?.addrs[addrId];
      
      addrs.forEach((addr) => {
        const found = acc.find(
          (a) => a[0] == addrId && a[1] == addr[0] && a[2] == addr[1],
        );
        if (found) return;

        acc.push([addrId, ...addr]);
      });
    }

    return acc;
  }, [] as [addrId: string, ...addr: Addr][]);

  addrs.sort((a, b) => {
    const A = Number(a[0]);
    const B = Number(b[0]);
    if (A < B) return -1;
    if (A > B) return 1;
    return 0;
  });

  return addrs;
});
const fmis = computed(() => {
  const fmisArr = props.data.data.objects.reduce((acc, object) => {
    if (!object.posDtcLabels?.fmis) {
      return acc;
    }

    for (const fmiId in object.posDtcLabels?.fmis) {
      const fmi = object.posDtcLabels?.fmis[fmiId];

      const found = acc.find((a) => a[0] == fmiId);
      if (found) continue;

      acc.push([fmiId, ...fmi]);
    }

    return acc;
  }, [] as [fmiId: string, ...fmi: Fmi][]);

  fmisArr.sort((a, b) => {
    const A = Number(a[0]);
    const B = Number(b[0]);
    if (A < B) return -1;
    if (A > B) return 1;
    return 0;
  });

  return fmisArr;
});

watch(groupBy, async (option) => {
  loading.value = true;
  await wait(0.1);

  if (!option) {
    removeGrouping();
    sortTable();
    loading.value = false;
    return;
  }

  updateRows();

  if (option.value === 'code') {
    groupByCode();
    sortTable();
    loading.value = false;
    return;
  }
  if (option.value === 'fault') {
    groupByFault();
    sortTable();
    loading.value = false;
    return;
  }
});

watch(sortBy, () => {
  if (descending.value === DEFAULT_DESCENDING) {
    sortTable();
  } else {
    descending.value = DEFAULT_DESCENDING;
  }
});
watch(descending, sortTable);

onMounted(() => {
  clearArea();
  setSettings();
  updateRows();
});

function groupByCode() {
  const temp: {
    [Code: number]: {
      name: string;
      stateNumber: string;
      time: number;
      interval: number;
    };
  } = {};
  rows.forEach((row) => {
    let code = row.code;

    if (code === undefined || code === null) {
      return;
    }

    code = Number(code);

    const begin = Number(row.begin);

    if (temp[code]) {
      temp[code].interval += Number(row.interval);
      if (begin > temp[code].time) {
        temp[code].time = begin;
      }
    } else {
      temp[code] = {
        name: String(row.name),
        stateNumber: String(row.stateNumber),
        time: begin,
        interval: Number(row.interval),
      };
    }
  });

  rows.length = 0;

  for (const code in temp) {
    const tempValue = temp[code];

    const row = {
      code,
      name: '',
      stateNumber: '',
      begin: 0,
      interval: 0,
    };
    row.name = tempValue.name;
    row.stateNumber = tempValue.stateNumber;
    row.begin = tempValue.time;
    row.interval = tempValue.interval;

    rows.push(row);
  }
}

function groupByFault() {
  const temp: {
    [key: string]: {
      [key: string]: any;
    };
  } = {};
  rows.forEach((row) => {
    const { code, mif, is, os, lamp1, lamp2, addr, priority } = row;

    const key = `${code}#${mif}#${is}#${os}#${lamp1}#${lamp2}#${addr}#${priority}`;
    const begin = Number(row.begin);

    if (temp[key]) {
      temp[key].interval += Number(row.interval);
      if (begin > temp[key].begin) {
        temp[key].begin = begin;
      }
    } else {
      temp[key] = {
        name: String(row.name),
        stateNumber: String(row.stateNumber),
        begin,
        interval: Number(row.interval),
        code,
        mif,
        is,
        os,
        lamp1,
        lamp2,
        addr,
        priority,
      };
    }
  });

  rows.length = 0;

  for (const key in temp) {
    const tempValue = temp[key];

    rows.push(tempValue);
  }
}

function removeGrouping() {
  updateRows();
}

function sortByParamName(
  paramName: SortBy['value'] | typeof DEFAULT_SORT_COLUMN_NAME,
) {
  rows.sort((a, b) => {
    if (descending.value) {
      return String(a.name) === String(b.name)
        ? Number(a[paramName]) - Number(b[paramName])
        : -1_000_000;
    } else {
      return String(b.name) === String(a.name)
        ? Number(b[paramName]) - Number(a[paramName])
        : -1_000_000;
    }
  });
}

function removeSorting() {
  descending.value = DEFAULT_DESCENDING;
  sortByParamName(DEFAULT_SORT_COLUMN_NAME);
}

async function sortTable() {
  loading.value = true;
  await wait(0.1);
  if (sortBy.value) {
    sortByParamName(sortBy.value.value);
  } else {
    removeSorting();
  }

  loading.value = false;
}

function updateRows() {
  rows.length = 0;
  props.data.data.objects.forEach((object, objectIndex) => {
    const summRow = {
      name: SUMM_ROW_NAME,
      stateNumber: object.stateNumber,
      interval: 0,
      redLampInterval: 0,
      yellowLampInterval: 0,
      CO2ErrorInterval: 0,
      noSubsystemErrorInterval: 0,
    };

    const objectRows = {
      start: rows.length,
      end: rows.length,
    };
    object.Periods.forEach((period: IPeriod) => {
      period.diagnostic.forEach((diagnosticRow: any) => {
        rows.push(diagnosticRow);
        if (props.name === 'descriptionDiagnostic') {
          if (rows.length > objectRows.start + 1) {
            rows[objectRows.end].model =
              rows.length - objectRows.start === 2 ? object.can_moto_delta : '';
          }
        }
        objectRows.end += 1;

        summRow.interval += diagnosticRow?.interval || 0;
        summRow.redLampInterval += diagnosticRow?.redLampInterval || 0;
        summRow.yellowLampInterval += diagnosticRow?.yellowLampInterval || 0;
        summRow.CO2ErrorInterval += diagnosticRow?.CO2ErrorInterval || 0;
        summRow.noSubsystemErrorInterval +=
          diagnosticRow?.noSubsystemErrorInterval || 0;
      });
    });

    if (object.cnt_real_pos === 0) {
      rows.push({
        name: object.name,
        stateNumber: object.stateNumber,
        model: object.model,
        begin: NOT_DATA,
        interval: NOT_DATA,
        code: NOT_DATA,
        mif: NOT_DATA,
        is: NOT_DATA,
        os: NOT_DATA,
        lamp1: NOT_DATA,
        lamp2: NOT_DATA,
        redLampInterval: NOT_DATA,
        yellowLampInterval: NOT_DATA,
        CO2ErrorInterval: NOT_DATA,
        noSubsystemErrorInterval: NOT_DATA,
        addr: NOT_DATA,
        priority: NOT_DATA,
        posDtcLabels: null,
      });
    } else if (objectRows.start === objectRows.end) {
      rows.push({
        name: object.name,
        stateNumber: object.stateNumber,
        model: object.model,
        begin: EMPTY,
        interval: EMPTY,
        code: NOT_VIOLATION,
        mif: EMPTY,
        is: EMPTY,
        os: EMPTY,
        lamp1: EMPTY,
        lamp2: EMPTY,
        redLampInterval: EMPTY,
        yellowLampInterval: EMPTY,
        CO2ErrorInterval: EMPTY,
        noSubsystemErrorInterval: EMPTY,
        addr: EMPTY,
        priority: EMPTY,
        posDtcLabels: EMPTY,
      });
    }

    if (props.name === 'descriptionDiagnostic') {
      if (objectRows.start === objectRows.end) {
        return;
      }
      rows.push(summRow);
      for (let i = objectRows.start; i < objectRows.end + 1; i++) {
        rowsStyles[i] = {
          'background-color': objectIndex % 2 !== 0 ? '#ededed' : '#fff',
        };
      }
    }
  });
}

async function setSettings() {
  if (props.name === 'diagnostic') {
    const settings = props.data.data.templateSettings || {};

    await wait(0);
    groupBy.value = settings.groupBy;

    await wait(0);
    sortBy.value = settings.sortBy;

    await wait(0);
    descending.value =
      settings.descending === undefined
        ? DEFAULT_DESCENDING
        : settings.descending;
  }
}

function toggleDescending() {
  descending.value = !descending.value;
}

function clearArea() {
  const area = document.getElementById(props.areaId);

  if (area) area.innerHTML = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: props.areaId
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "not-print float-left",
        onClick: _cache[0] || (_cache[0] = 
          (e) =>
            {
              const id = props.name === 'diagnostic' ? 'diagnostic-template-content' : 'diagnostic-detail-template-content'
              return _unref(html_to_excel_helper).export(
              e.target,
              id,
              _unref(REPORT_LABEL),
              'landscape',
            )}
        )
      }, " Экспорт в EXCEL ")
    ]),
    _createElementVNode("div", {
      class: "temlate-report",
      id: props.name === 'diagnostic' ? 'diagnostic-template-content' : 'diagnostic-detail-template-content'
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-end not-excel", [
            props.name === 'diagnostic' ? 'justify-start' : 'justify-center',
          ]])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", {
              class: "text-center footer-desc mb-1 mt-0",
              innerHTML: _unref(REPORT_LABEL)
            }, null, 8, _hoisted_6),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(interval)) + ". Отчет сформирован " + _toDisplayString(_unref(formatTimeHelper2)(new Date())), 1)
          ]),
          (props.name === 'diagnostic')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_9,
                    _createElementVNode("td", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((groupBy).value = $event)),
                        class: "px-1 py-1",
                        style: {"width":"150px"}
                      }, [
                        _hoisted_11,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GROUP_BY_OPTIONS), (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option.value,
                            value: option,
                            innerHTML: option.label
                          }, null, 8, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, groupBy.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
                          class: "px-1 py-1",
                          style: {"width":"150px"}
                        }, [
                          _hoisted_16,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SORT_BY_OPTIONS), (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option.value,
                              value: option,
                              innerHTML: option.label
                            }, null, 8, _hoisted_17))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, sortBy.value]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm ml-1",
                          innerHTML: descending.value ? '▲' : '▼',
                          onClick: toggleDescending
                        }, null, 8, _hoisted_18)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("h5", {
        class: "text-center footer-desc my-1 mt-2 d-none",
        innerHTML: _unref(REPORT_LABEL)
      }, null, 8, _hoisted_19),
      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(interval)) + ". Отчет сформирован " + _toDisplayString(_unref(formatTimeHelper2)(new Date())), 1),
      (groupBy.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Группировка по: " + _toDisplayString(groupBy.value.label), 1))
        : _createCommentVNode("", true),
      (sortBy.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Сортировка по: " + _toDisplayString(sortBy.value.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_23, [
        _createElementVNode("thead", _hoisted_24, [
          _createElementVNode("tr", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(COLUMNS_BY_REPORT_NAME[props.name], (col, colIndex) => {
              return (_openBlock(), _createElementBlock("th", _mergeProps({
                key: colIndex,
                class: [col.banner && 'target-show']
              }, col.headAttrs, {
                onMouseenter: ($event: any) => (col.banner && _unref(addHoverOnTarget)($event)),
                onMouseleave: ($event: any) => (col.banner && _unref(removeHoverOnTarget)($event))
              }), [
                _createElementVNode("span", {
                  innerHTML: col.label
                }, null, 8, _hoisted_27),
                (col.banner)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "target-show-span",
                      innerHTML: col.banner
                    }, null, 8, _hoisted_28))
                  : _createCommentVNode("", true)
              ], 16, _hoisted_26))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(COLUMNS_BY_REPORT_NAME[props.name], (col, colIndex) => {
                return (_openBlock(), _createElementBlock("td", _mergeProps({ key: colIndex }, col.bodyAttrs && col.bodyAttrs(row, colIndex), {
                  innerHTML: col.format(row, colIndex)
                }), null, 16, _hoisted_29))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      (props.name === 'descriptionDiagnostic')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_30,
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("table", _hoisted_33, [
              _createElementVNode("thead", _hoisted_34, [
                _createElementVNode("tr", _hoisted_35, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ADDRESS_COLUMNS, (col, colIndex) => {
                    return _createElementVNode("th", _mergeProps({
                      key: colIndex,
                      style: {"background-color":"#eee"}
                    }, col.headAttrs, {
                      innerHTML: col.label
                    }), null, 16, _hoisted_36)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addresses), (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ADDRESS_COLUMNS, (col, colIndex) => {
                      return _createElementVNode("td", _mergeProps({ key: colIndex }, col.bodyAttrs, {
                        innerHTML: col.format(row)
                      }), null, 16, _hoisted_37)
                    }), 64))
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_38,
            _createElementVNode("table", _hoisted_39, [
              _createElementVNode("thead", _hoisted_40, [
                _createElementVNode("tr", _hoisted_41, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FMI_COLUMNS, (col, colIndex) => {
                    return _createElementVNode("th", _mergeProps({
                      key: colIndex,
                      style: {"background-color":"#eee"}
                    }, col.headAttrs, {
                      innerHTML: col.label
                    }), null, 16, _hoisted_42)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fmis), (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FMI_COLUMNS, (col, colIndex) => {
                      return _createElementVNode("td", _mergeProps({ key: colIndex }, col.bodyAttrs, {
                        innerHTML: col.format(row)
                      }), null, 16, _hoisted_43)
                    }), 64))
                  ]))
                }), 128))
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ], 8, ["to"]))
}
}

})